import i18next, {} from "i18next";
import { NAMESPACES, resources, SUPPORTED_LOCALES } from "./resources.js";
/** A separate i18next instance per app (and per test), with every namespace bundled: no loading at runtime. */
export async function createI18n({ lng = "en", plugins = [] } = {}) {
    const instance = i18next.createInstance();
    for (const plugin of plugins)
        instance.use(plugin);
    await instance.init({
        resources,
        lng,
        fallbackLng: "en",
        supportedLngs: [...SUPPORTED_LOCALES],
        ns: NAMESPACES,
        defaultNS: "common",
        // React escapes output itself.
        interpolation: { escapeValue: false },
    });
    return instance;
}
export function isLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
//# sourceMappingURL=create-i18n.js.map